import { doSwaggerCall } from '../hooks/useApi';

export const replaceDashes = (object) => {
    return Object.keys(object || {}).reduce((acc, key) => {
        // we don't want to remove '-' from delete
        if (key === 'Törlés' && object[key] === '-') {
            acc[key] = '-';
        } else {
            acc[key] = object[key] === '-' ? undefined : object[key];
        }
        return acc;
    }, {});
};

export const addUser = async (item, handleSuccess, handleError) => {
    try {
        await doSwaggerCall('Users', 'createUser', null, {
            firstname: item.firstname.trim(),
            lastname: item.lastname.trim(),
            email: item.email.trim(),
            role: item.role.trim(),
            vipurl: item.vipurl?.trim(),
            lurdylifemember: item.lurdylifemember,
        });
        handleSuccess();
    } catch (err) {
        console.error(err);
        handleError();
    }
};

export const deleteUser = async (item, handleSuccess, handleError) => {
    try {
        await doSwaggerCall('Users', 'deleteUser', { id: Number(item.id) });
        handleSuccess();
    } catch (err) {
        console.error(err);
        handleError();
    }
};

export const updateUser = async (item, handleSuccess, handleError) => {
    try {
        await doSwaggerCall(
            'Users',
            'updateUser',
            { id: Number(item.id) },
            {
                firstname: item.firstname.trim(),
                lastname: item.lastname.trim(),
                lang: item.lang.trim(),
                role: item.role.trim(),
                vipurl: item.vipurl?.trim(),
                lurdylifemember: item.lurdylifemember,
            }
        );
        handleSuccess();
    } catch (err) {
        console.error(err);
        handleError();
    }
};
